
export const userColumns = [

    {
        field: "doctorName",
        headerName: "Doctor Name",
        width: 200,
    },
    {
        field: "mobileNumber",
        headerName: "Mobile Number",
        width: 200,
    },
    {
        field: "amount",
        headerName: "Amount",
        width: 200,
    },
    {
        field: "registrationNumber",
        headerName: "Registration Number",
        width: 200,
    },
    {
        field: "address",
        headerName: "Address",
        width: 200,
    },
   
    {
        field: "description",
        headerName: "Description",
        width: 200,
    },

];
